import { Component, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./layout/header/header";
import { ButtonModule } from 'primeng/button';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, ButtonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('CINT-App');
  private readonly _destroying$ = new Subject<void>();
  isReload?: boolean;
  isLoggedIn = false;
  userName: string = '';
  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router
  ) { }
  async ngOnInit() {
    try {
      // 1. Initialize MSAL
      await this.msalService.instance.initialize();

      // 2. IMPORTANT: Handle the redirect results
      const result = await this.msalService.instance.handleRedirectPromise();
      //If we aren't returning from a redirect , manually check the cache 
      if (!result) {
        const currentAccount = this.msalService.instance.getAllAccounts();

        if (currentAccount.length > 0) {
          this.isReload = true;
          this.msalService.instance.setActiveAccount(currentAccount[0]);

        }
      } else {
        this.isReload = false;
        this.msalService.instance.setActiveAccount(result.account);

      }

      this.checkAccount(); // Initial check
    } catch (error) {
      console.error("Init error:", error);
    }

    // 3. Listen for successful login events
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.checkAccount();
      });

    // 4. Update UI when interaction stops
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.router.initialNavigation()
        this.checkAccount();
      });

  }
  checkAccount() {
    const accounts = this.msalService.instance.getAllAccounts();
    const idToken = accounts[0]?.idToken;
    this.isLoggedIn = accounts.length > 0;    
    if (this.isLoggedIn) {
      this.msalService.instance.setActiveAccount(accounts[0]);
      this.userName = accounts[0].username;
      this.router.navigate(['list'])
    } else {
      this.router.navigate(['/Auth']);
    }

  }
}
